import { Injectable } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { GlobalDataService } from './global-data.service';
import { SharedListSalesforceService } from './shared-list-salesforce.service';
import { ChampsFusionService } from './champs-fusion.service';
import { ChampsFusion } from '@core/models/champsFusion.model';
import { getChampFusionIdentityKey, isPaveAdresseField } from '@core/utils/champs-fusion.utils';


@Injectable({
  providedIn: 'root'
})
export class PersonalisationService {

  public form!: FormGroup;

  public controls: any;

  champFusion: string;

  availableChampsFusion: Array<any> = [];
  filteredAvailableChampsFusion: Array<any> = [];
  selectedChampsFusion: Array<any> = [];

  private fusionRequestToken = 0;

  constructor(
    private _formBuilder: FormBuilder,
    public _GlobalDataService: GlobalDataService,
    private _ChampsFusionService: ChampsFusionService
  ) {
    this.controls = {
      champFusion: new FormControl(this.champFusion, [
      ]),
    };
    this.form = this._formBuilder.group(this.controls);
  }

  public initialise() {
    const persistedChampsFusion = this._GlobalDataService.CampagneExt?.ChampsFusion || [];
    this.selectedChampsFusion = persistedChampsFusion.filter(cf => !isPaveAdresseField(cf));

    if (this._GlobalDataService.isStandaloneContext()) {
      if ((this._GlobalDataService.availableEloquaChampsFusion || []).length > 0) {
        this.availableChampsFusion = (this._GlobalDataService.availableEloquaChampsFusion || []).map(cf => ({ ...cf }));
        this.rebuildFilteredAvailableChampsFusion();
        return;
      }

      this.updateChampFusion();
      return;
    }

    this.availableChampsFusion = (this._GlobalDataService.availableEloquaChampsFusion || []).map(cf => ({ ...cf }));
    this.rebuildFilteredAvailableChampsFusion();
  }

  public reset(): void {
    this.fusionRequestToken++;
    this.availableChampsFusion = [];
    this.filteredAvailableChampsFusion = [];
    this.selectedChampsFusion = [];
    this.form.reset({}, { emitEvent: false });
  }

  private rebuildFilteredAvailableChampsFusion() {
    const selectedKeys = new Set(
      this.selectedChampsFusion
        .map(cf => this.getChampFusionKey(cf))
        .filter((key): key is string => !!key)
    );
    this.filteredAvailableChampsFusion = this.availableChampsFusion.filter(
      acf => {
        const key = this.getChampFusionKey(acf);
        return !key || !selectedKeys.has(key);
      }
    );

    this.selectedChampsFusion = this.selectedChampsFusion.map(cf => ({ ...cf }));
    this.filteredAvailableChampsFusion = this.filteredAvailableChampsFusion.map(cf => ({ ...cf }));
  }

  /**
   * Returns the stable business identity of a contact field.
   * Standalone contact fields use Id=0 and internalName="null" for every
   * column, so those transport values cannot be used for de-duplication.
   */
  public getChampFusionKey(champFusion: ChampsFusion): string | null {
    return getChampFusionIdentityKey(champFusion);
  }

  public setChampFusionType() {
    this.selectedChampsFusion.forEach((value, index) => {
      this.selectedChampsFusion[index].Sequence = index;
      this.selectedChampsFusion[index].IsPaveAdresse = 'false';
    });
  }

  public updateChampFusion(onUpdated?: () => void) {
    const requestToken = ++this.fusionRequestToken;
    const campagne = this._GlobalDataService.Campagne;
    if (!campagne?.IdCampagne || campagne.importOption === 'sftp' || !campagne.importFile) {
      this.availableChampsFusion = [];
      this.filteredAvailableChampsFusion = [];
      this._GlobalDataService.availableEloquaChampsFusion = [];
      this.rebuildFilteredAvailableChampsFusion();
      onUpdated?.();
      return;
    }
    this._ChampsFusionService.listChampsDisponibleStandalone().subscribe({
      next: (response) => {
        if (requestToken !== this.fusionRequestToken) {
          return;
        }
        this.availableChampsFusion = [];
        this.filteredAvailableChampsFusion = [];
        const contactFields = Array.isArray(response)
          ? response
          : (response?.ContactFields || response?.contactFields || []);
        for (let i = 0; i < contactFields.length; i++) {
          const CF: ChampsFusion = {
            Id: contactFields[i].Id,
            ChampFusion: contactFields[i].FieldName || contactFields[i].fieldName,
            internalName: contactFields[i].internalName,
          };
          this.availableChampsFusion.push(CF);
        }
        this._GlobalDataService.availableEloquaChampsFusion = this.availableChampsFusion.map(cf => ({ ...cf }));
        this.rebuildFilteredAvailableChampsFusion();
        onUpdated?.();
      },
      error: (err) => {
        console.error('[PERSO] updateChampFusion() ERROR:', err);
        if (requestToken !== this.fusionRequestToken) {
          return;
        }
        this.availableChampsFusion = [];
        this.filteredAvailableChampsFusion = [];
        this._GlobalDataService.availableEloquaChampsFusion = [];
        this.rebuildFilteredAvailableChampsFusion();
        onUpdated?.();
      }
    });
  }

}
